import React from 'react';
import SEO from '../../components/ui/SEO';
import ServicePageTemplate from '../../components/ui/ServicePageTemplate';
import { servicePages } from '../../data/services';
export default function TraumaPTSD() {
  return <main className="min-h-screen bg-white" data-id="element-1146" data-mp="1oa73qycjds75">
      <SEO title="PTSD Psychiatric Expert Report | Complex Trauma Assessments" description="Independent PTSD and complex PTSD psychiatric expert reports, including Istanbul Protocol and trafficking cases. Request a fee quote." path="/services/trauma-ptsd" keywords={['PTSD psychiatric expert report', 'complex PTSD medico-legal report', 'Istanbul Protocol psychiatric report']} imageAlt="PTSD and complex trauma psychiatric expert reports" schema={{
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'PTSD and Complex Trauma Reports',
      serviceType: 'PTSD and psychiatric injury assessment',
      url: 'https://medicolegal-psychiatry.co.uk/services/trauma-ptsd',
      areaServed: {
        '@type': 'AdministrativeArea',
        name: 'England and Wales'
      },
      provider: {
        '@type': 'Organization',
        name: 'Medicolegal Psychiatry',
        url: 'https://medicolegal-psychiatry.co.uk'
      },
      audience: {
        '@type': 'Audience',
        name: 'Legal professionals'
      },
      description: 'Assessment of PTSD, complex PTSD and other trauma-related conditions, addressing diagnosis, severity, treatment and prognosis.'
    }} data-id="element-1147" data-mp="1od1jwdoioqur" />
      <ServicePageTemplate content={servicePages.ptsd} data-id="element-1148" data-mp="2hr8wecegi9i9" />
    </main>;
}